import type { QuizQuestionType, QuizResultsType, TieBreakersQuestionType } from '../../../flowTypes'
import type { StateType } from './Quiz'

export type QueryType = { [key: string]: string }

/**
 * Returns a state object or rehydrate quiz,
 * useful for social auth redirects on instagram and facebook web views,
 * or if the user refreshes
 * @param query
 * @param quiz
 * @param tieBreakers
 * @returns {{showProgressBar: boolean, eventInfo: [], showCreateAccount: boolean, currentQuestionIndex: (number|number), showResultsScreen: boolean, transitioning: boolean, genderPreference: null, socialAuth: boolean, answers: [], currentQuestion: QuizQuestionType, finalResult: null}}
 */
export function parseQuery (query: QueryType, quiz: QuizQuestionType[], tieBreakers: TieBreakersQuestionType[]): StateType {
  const eventInfo: any[] = []
  const answers: any[] = []
  let genderPreference = null
  let currentQuestion = quiz[0]

  Object.keys(query || {}).forEach((key: string): void => {
    if (key.includes('q') && key.length === 2) {
      const qIndex = parseInt(key.replace('q', ''))
      const question = quiz.filter((quizItem: QuizQuestionType): boolean => quizItem.index === qIndex)[0]
      answers.push(question.answers[parseInt(query[key])].outcomes)
      if (question.genderPref) {
        genderPreference = question.answers[parseInt(query[key])].genderPrefText
      }
      eventInfo.push({
        question: question.questionText,
        answer: question.answers[parseInt(query[key])].text
      })
      currentQuestion = quiz[qIndex + 1]
    }

    if (key.includes('t') && key.length === 2) {
      const qIndex = parseInt(key.replace('t', ''))
      const question = tieBreakers.filter((quizItem: TieBreakersQuestionType): boolean => quizItem.index === qIndex)[0]
      answers.push(question.answers[parseInt(query[key])].outcomes)
      currentQuestion = tieBreakers[qIndex + 1]
    }
  })
  const currentQuestionIndex = answers.length ? answers.length : 0

  return {
    currentQuestionIndex,
    currentQuestion,
    answers,
    eventInfo,
    showProgressBar: !query.socialAuth,
    transitioning: !query.socialAuth,
    showCreateAccount: false,
    showResultsScreen: query.socialAuth === '1',
    finalResult: null,
    socialAuth: query.socialAuth === '1',
    genderPreference
  }
}

export function quizResult (quizResults: QuizResultsType, answers: string[][], genderPref: string, log: boolean = false): string[] {
  const uniqueObj: Record<string, any> = {}
  answers.flat().forEach((flatAnswer: string): void => {
    if (genderPref === 'Both' || genderPref === quizResults[flatAnswer].genderPref) {
      if (uniqueObj[flatAnswer]) {
        uniqueObj[flatAnswer] = uniqueObj[flatAnswer] + 1
      } else {
        uniqueObj[flatAnswer] = 1
      }
    }
  })
  let winners: any[] = []
  const uniqueArr = Object.keys(uniqueObj || {})
  const sortedArr = uniqueArr.sort(
    (a: string, b: string): number => uniqueObj[b] - uniqueObj[a]
  )
  if (genderPref === 'Both' && answers.length === 6) {
    // in the case of both gender pref, we'll take the top two winners
    winners = sortedArr.slice(0, 2)
  } else if (genderPref === 'Both' && answers.length === 7) {
    // in the case of a tiebreaker, the winner is the answer result
    winners = answers[answers.length - 1]
  } else {
    sortedArr.forEach((item: string): void => {
      const itemRank = uniqueObj[item]
      if (winners.length > 0) {
        if (
          itemRank > uniqueObj[winners[0]] &&
          itemRank !== uniqueObj[winners[0]]
        ) {
          winners = [item]
        } else if (itemRank === uniqueObj[winners[0]]) {
          winners.push(item)
        }
      } else {
        winners.push(item)
      }
    })
  }

  if (log) {
    console.log(genderPref)
    console.log(answers)
    console.log(uniqueObj)
    console.log(winners)
  }
  return winners
}
